import AccessLog from './accessLog';
import connectionGroup from './connectionGroup';
import connections from './connections';
import delegatedTasks from './delegatedTasks';
import delegationConfigurations from './delegationConfigurations';
import delegations from './delegations';
import DynamicEntity from './dynamicEntity';
import emailMessageTrace from './emailMessageTrace';
import FormInstanceData from './formInstanceData';
import InstanceActionType from './instanceActionType';
import ManageAgents from './manageAgents';
import ManageEntities from './manageEntities';
import ManageLists from './manageLists';
import ManageProcess from './manageProcess';
import ManageProcessPortalConfig from './manageProcessPortalConfig';
import ManageReports from './manageReports';
import ManageSequenceTracing from './manageSequenceTracing';
import ManageSubSequence from './manageSubSequence';
import ManageTokenTrace from './manageTokenTrace';
import NameAndDescription from './nameAndDescription';
import NameDescriptionIsActive from './nameDescriptionIsActive';
import ProcessGroup from './processGroup';
import ProcessInstanceDetails from './processInstanceDetails';
import Requests from './requests';
import Tasks from './tasks';
import Trace from './trace';
import aiConsumption from './aiConsumption';
import userGroup from './userGroup';
import UserPosition from './userPosition';
import ShortenedUrl from './shortenedUrl';

/** Namespace to serve DB Queries */
const CoreQueries = (() => {
  return {
    Requests,
    ProcessInstanceDetails,
    FormInstanceData,
    ManageReports,
    ManageProcess,
    ManageAgents,
    ManageLists,
    UserPosition,
    ManageEntities,
    NameAndDescription,
    AccessLog,
    NameDescriptionIsActive,
    Trace,
    aiConsumption,
    ProcessGroup,
    Tasks,
    ManageSubSequence,
    ManageSequenceTracing,
    ManageTokenTrace,
    InstanceActionType,
    ManageProcessPortalConfig,
    userGroup,
    connections,
    emailMessageTrace,
    connectionGroup,
    delegations,
    delegationConfigurations,
    delegatedTasks,
    DynamicEntity,
    ShortenedUrl,
  };
})();

export default CoreQueries;
